<template>
  <div class="context-switch-wrapper">
    <!-- Desktop version -->
    <div class="hidden-sm-and-down">
      <v-btn-toggle
        v-model="selectedContext"
        mandatory
        color="primary"
        class="context-toggle elevation-2"
      >
        <v-btn
          v-for="ctx in contexts"
          :key="ctx.value"
          :value="ctx.value"
          class="context-btn"
          :style="selectedContext === ctx.value ? buttonStyle(ctx) : {}"
        >
          <v-icon left>{{ ctx.icon }}</v-icon>
          <span class="btn-text">{{ ctx.label }}</span>
          <span class="btn-count">{{ ctx.count }}</span>
        </v-btn>
      </v-btn-toggle>
    </div>

    <!-- Mobile version -->
    <div class="hidden-md-and-up">
      <v-btn-toggle
        v-model="selectedContext"
        mandatory
        color="primary"
        class="context-toggle-mobile elevation-2"
      >
        <v-btn
          v-for="ctx in contexts"
          :key="ctx.value"
          :value="ctx.value"
          class="context-btn-mobile"
          small
          :style="selectedContext === ctx.value ? buttonStyle(ctx) : {}"
        >
          <v-icon small>{{ ctx.icon }}</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

const CONTEXTS = {
  poissonnerie: { label: 'Poissonnerie', icon: 'mdi-fish', color: '#376374' },
  boucherie: { label: 'Boucherie', icon: 'mdi-food-steak', color: '#9d0419' }
}

export default {
  name: 'ContextSwitch',
  computed: {
    ...mapState({
      context: state => state.enseignes.context
    }),
    ...mapGetters(['countByContext']),
    contexts() {
      return Object.keys(CONTEXTS).map(value => ({
        value,
        ...CONTEXTS[value],
        count: this.countByContext[value]
      }))
    },
    selectedContext: {
      get() {
        return this.context
      },
      set(value) {
        this.$store.dispatch('setContext', value)
        // Réinitialiser le magasin sélectionné lors du changement de contexte
        this.$store.dispatch('setCurrentEnseigne', {})
        // Ne pas réinitialiser le zoom - garder la vue actuelle
        // this.$store.dispatch('resetZoom')
        // Changer la couleur du thème
        this.updateThemeColor(value)
      }
    },
  },
  mounted() {
    // Appliquer la couleur au montage du composant
    this.updateThemeColor(this.context)
  },
  methods: {
    buttonStyle(ctx) {
      return {
        backgroundColor: ctx.color + ' !important',
        borderColor: ctx.color + ' !important'
      }
    },
    updateThemeColor(context) {
      this.$vuetify.theme.themes.light.primary = CONTEXTS[context].color
    }
  }
}
</script>

<style lang="scss" scoped>
.context-switch-wrapper {
  pointer-events: auto;
}

.context-toggle {
  background-color: white !important;
  border-radius: 25px !important;
  overflow: hidden;
  border: 2px solid #e0e0e0 !important;
  
  ::v-deep .v-btn {
    border: none !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    font-weight: 500 !important;
    height: 50px !important;
    padding: 0 24px !important;
    transition: all 0.3s ease;
    
    &:not(.v-btn--active) {
      background-color: white !important;
      color: #757575 !important;
      
      .v-icon {
        color: #757575 !important;
      }
      
      &:hover {
        background-color: #f5f5f5 !important;
      }
    }
    
    &.v-btn--active {
      color: white !important;
      
      .v-icon {
        color: white !important;
      }
    }
  }
  
  .btn-text {
    margin-left: 4px;
  }

  .btn-count {
    margin-left: 8px;
    min-width: 26px;
    padding: 1px 7px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    line-height: 16px;
    background-color: rgba(0, 0, 0, 0.08);
    color: inherit;
  }

  ::v-deep .v-btn--active .btn-count {
    background-color: rgba(255, 255, 255, 0.25);
  }
}

.context-toggle-mobile {
  background-color: white !important;
  border-radius: 20px !important;
  overflow: hidden;
  border: 2px solid #e0e0e0 !important;
  
  ::v-deep .v-btn {
    border: none !important;
    min-width: 44px !important;
    width: 44px !important;
    height: 44px !important;
    padding: 0 !important;
    transition: all 0.3s ease;
    
    &:not(.v-btn--active) {
      background-color: white !important;
      color: #757575 !important;
      
      .v-icon {
        color: #757575 !important;
      }
    }
    
    &.v-btn--active {
      color: white !important;
      
      .v-icon {
        color: white !important;
      }
    }
  }
}

.context-btn,
.context-btn-mobile {
  transition: all 0.3s ease !important;
}

</style>
